import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
import '../Work.css';
import { useNavigate } from "react-router-dom";
import logo2 from "../../assets/Images/logo2.png";
import logoprocess from "../../assets/Images/process.png";
import octalumelogo from "../../assets/Images/OctalumeLogo.png";





const WorkGroupLogo = () => {
    const navigate = useNavigate();

    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-work-headings">
                <h1>Group Logo</h1>
                <p>This was the Process of our Group Logo</p>

                
            </div>

            <div className="line"></div>

            <div className="content-work">
                <div className="content-work-group-logo">

                    <div className="content-work-group-logo-text">
                        <h1>Octolume Logo</h1>
                        <p>I made this logo using Adobe Illustrator, from the sketch that one of my group mates made.
                            I tried to digitalized it so and this was the last version that I made.
                        </p>
                        <p>The first step that we took was actually to design each of our logo and have a vote between our logo</p>
                        <p>So this logo was made from my groupmates idea where this Octopus holds a light where the idea was that we could guide our clients with our light</p>

                    </div>

                    <div className="content-work-group-logo-image">
                        <img src={logo2}></img>
                    </div>

                    <div className="content-work-group-logo-image1">
                        <img src={logoprocess}></img>
                    </div>
                    
                    <div className="content-work-group-logo-text1">
                        <p>During this phase I continue to itterate towards all the feedback that was given from teachers and students.</p>
                        <p>But at the end one of my groupmate sam manage to do a better design where we all agree to use it as our brand logo, you can see it on the right</p>
                    </div>

                    <div className="content-work-group-logo-image2">
                        <img src={octalumelogo}></img>
                    </div>

                </div>
            </div>

            <Footer />
            </div>
    );
};

export default WorkGroupLogo;